// extracted by mini-css-extract-plugin
export default {"root":"Chips_root__yfhMM","content":"Chips_content__UDPgr","activeContent":"Chips_activeContent__aSyJH","active":"Chips_active__UoCws","imgButton":"Chips_imgButton__WE3C4"};